module.exports = __webpack_public_path__ + "static/media/industry_leading_light.3f5606eb.svg";